import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';
import Modal from '@components/Modal';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import s from './EditListItemModal.module.scss';

type Props = {
  field: Pick<QuestionnaireApiModels.FieldTemplate, 'label'>;
  onClose: () => void;
  rowIndex: number;
  referencedListData?:
    & NonNullable<Parameters<typeof Modal>['0']['referencedListData']>
    & { _id: string };
  listSubsections: string[];
};

const ModalWrapper: React.FC<Props> = ({
  children,
  field,
  onClose,
  rowIndex,
  listSubsections,
  referencedListData,
}) => {
  const { isEnabled } = useQuestionnaireContext();
  return (
    <Modal
      title={`Edit ${field.label} item`}
      onClose={onClose}
      referencedListData={referencedListData}
      isWide
      hasForm={isEnabled}
      fixedHeight={listSubsections.length > 0 ? "80vh" : undefined}
      // use key to have react unmount -> mount when the referencedListData changes
      key={`${rowIndex}-${referencedListData?._id || ''}`}
    >
      <div className={s.modal}>
        {children}
      </div>
    </Modal>
  );
};

export default ModalWrapper;
